<template>
  <nav class="rx-original-analysis-preview" :aria-label="title + ' 바로가기'">
    <div class="rx-original-analysis-heading"><span>기존 익스퍼트 분석</span><p>확인할 분석을 선택하세요.</p></div>
    <router-link v-for="item in analyses" :key="item.url" :to="{path:'/'+item.category,query:{q:item.name}}" class="rx-original-analysis-link">
      <span><strong>{{ item.name }}</strong><small>{{ item.description }}</small><em>{{ levels[item.authorityLevel] }} 이상</em></span><b aria-hidden="true">↗</b>
    </router-link>
  </nav>
</template>
<script>
const original = (name,url,description,authorityLevel=100,category='realestate')=>({name,url,description,authorityLevel,category});
export const serviceOriginalPreviews = {
  value:{title:'매매·전세 관계와 저평가 지표',analyses:[
    original('매매전세지수 플라워차트(시도)','real_priceindex_stat/index_flower_sd_01','시도별 매매·전세 흐름과 저평가 지표'),
    original('매매전세지수 플라워차트(시군구)','real_priceindex_stat/index_flower_sgg_01','시군구별 지표와 저평가 순위')
  ]},
  price:{title:'지역의 가격 흐름과 전세가율',analyses:[
    original('지역별 시세·지수 흐름 비교','real_richgo_ai_price_region/region_several_price_trend_01','리치고·KB·한국부동산원의 시세와 지수 비교'),
    original('매매전세지수 전세가율(시군구)','real_priceindex_stat/index_rent_price_deviation_01','시도·시군구의 전세가율 확인')
  ]},
  supply:{title:'입주물량과 미분양',analyses:[
    original('차트 분석','real_demand2/supply_volume_02','지역별 입주물량을 연·분기·월 단위로 확인'),
    original('미분양','real_demand2/unsold_02','공사 완료 전·후 미분양 비교')
  ]},
  gap:{title:'전세가율과 단지의 가격 관계',analyses:[
    original('전국 전세가율 현황','real_gap/total_status_01','지역의 전세가율 현황 비교',300),
    original('전세대비 저평가 아파트 찾기','real_danji/price_rank_02','매매·전세 변화와 저평가 기준으로 단지 찾기',200)
  ]},
  region:{title:'지역의 주요 지표를 한곳에서',analyses:[
    original('시도별 분석','real_region_summary1_richgo/sd_01','시도의 가격·입주·미분양·수급·인구 확인'),
    original('시군구별 분석','real_region_summary2_richgo/sgg_01','관심 시군구의 주요 시장 지표 확인')
  ]},
  korea:{title:'경제 규모와 아파트 시장',analyses:[
    original('M1/M2 통화량 대비 시가총액','eco_korea_cap/cap_m1_m2_01','통화량과 아파트 시가총액 비교',100,'economy'),
    original('GDP 대비 시가총액','eco_korea_gdp/gdp_cap_01','GDP와 아파트 시장의 흐름 비교',100,'economy')
  ]}
};
export default {
  props:{analyses:{type:Array,required:true},title:{type:String,required:true}},
  data:()=>({levels:{100:'일반',200:'고급',300:'프리미엄'}})
};
</script>
<style scoped>
.rx-original-analysis-preview{padding:22px 24px 12px;background:#f6f8fc;color:#23354c;text-align:left}
.rx-original-analysis-heading>span{font-size:11px;font-weight:700;color:#215bea}.rx-original-analysis-heading p{margin:7px 0 18px;font-size:14px;font-weight:600;line-height:1.6}
.rx-original-analysis-link{display:flex;align-items:center;gap:20px;padding:18px 0;border-top:1px solid #dce4ee;color:#23354c;text-decoration:none;transition:color .18s ease}
.rx-original-analysis-link>span{flex:1;min-width:0}.rx-original-analysis-link strong{display:block;font-size:15px;font-weight:700;line-height:1.6;word-break:keep-all}.rx-original-analysis-link small{display:block;margin-top:5px;color:#53677f;font-size:12px;line-height:1.65;word-break:keep-all}.rx-original-analysis-link em{display:block;margin-top:9px;color:#52667f;font-size:11px;font-style:normal}.rx-original-analysis-link b{color:#215bea;font-size:19px;font-weight:500}.rx-original-analysis-link:hover strong{color:#215bea}.rx-original-analysis-link:focus-visible{outline:3px solid #215bea;outline-offset:4px}
@media(max-width:720px){.rx-original-analysis-preview{padding:18px 16px 8px}.rx-original-analysis-link{gap:12px}.rx-original-analysis-link strong{font-size:14px}.rx-original-analysis-link small{font-size:12px}}
</style>
